import React from "react";
import Close from "../../../../../../images/Close.svg";
import { Title } from "../../../../../../stories/Title/Title";
import { Button } from "../../../../../../stories/Button/Button";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../../styles/Variables";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import { TableHeaderProps } from "../../../../../../utils/types";
import {
  GridColDef,
  GridValidRowModel,
  GridAlignment,
  GridCellParams,
} from "@mui/x-data-grid-pro";
import Assign from "../../../../../../images/Assign.svg";
import useLabels from "../../../../../../customHooks/useLabels";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const Data = [
  {
    item_desc: "Demo",
    warranty: 0,
    qty: 1,
    rate: 2,
    other_charges: 0,
    taxable_rate: 0,
    tax_perc: 0,
    total: 0,
    any_installation: 0,
    net_total: 0,
    remark: "same remark",
  },
];
const RfqItems = ({ setModalFlag }: Props) => {
  const { Purchase } = useAssetTableJson();
  const dynamicHeaders: TableHeaderProps[] =
    Purchase.PurchaseOrder.RfqItems.map((header) => ({
      headerName: header.headerName,
      field: header.field,
      cellClassName: header.cellClassName,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      renderCell: (params) => {
        if (params.row.id === 1 && header.field === "actions") {
          return (
            <>
              <button className="mrf-details__tableblock--choose">
                Choose RFQ <img src={Assign} alt="" />{" "}
              </button>
            </>
          );
        }
        return params.value;
      },
    }));
  const columns: GridColDef[] = [...dynamicHeaders];
  const rows: GridValidRowModel[] =
    (Data || []).map((data, index) => {
      return {
        id: index + 1,
        item_desc: data.item_desc,
        qty: data.qty,
        warranty: data.warranty,
        rate: data.rate,
        other_charges: data.other_charges,
        taxable_rate: data.taxable_rate,
        tax_perc: data.tax_perc,
        total: data.total,
        any_installation: data.any_installation,
        net_total: data.net_total,
        actions: "",
      };
    }) || [];

  const getRow = () => {
    if (Data.length) {
      return [
        {
          id: [],
          item_desc: [],
          uom: [],
          warranty: "Total",
          qty: 0,
          rate: 0,
          other_charges: 0,
          taxable_rate: 0,
          tax_perc: 0,
          total: 0,
          any_installation: 0,
          net_total: 0,
          actions: [],
        },
      ];
    }
    return [];
  };

  const pinnedRows = {
    bottom: getRow(),
  };

  const getCellClassName = (params: GridCellParams) => {
    const pinnedRowIds = pinnedRows.bottom
      ? pinnedRows.bottom.map((row) => row.id)
      : [];

    const isPinnedRow = pinnedRowIds.includes(params.row.id);

    if (isPinnedRow) {
      switch (params.field) {
        case "other_charges":
        case "rate":
        case "qty":
        case "taxable_rate":
        case "total":
        case "any_installation":
        case "net_total":
          return "total-count";
        case "warranty":
          return "total";
        default:
          return "hide-td";
      }
    }

    return "";
  };
  const {itemLabel}=useLabels();
  return (
    <>
      <div className="mrf-item-desc">
        <div className="mrf-item-desc__title">
          <Title>RFQ {itemLabel} Information</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <div className="mrf-item-desc__header">RFQ001</div>
        <div className="mrf-item-desc__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            getCellClassName={getCellClassName}
            disableRowSelectionOnClick
            hideFooter
            pinnedRows={pinnedRows}
          />
        </div>
        <Button mode="cancel" onClick={() => setModalFlag(false)} />
      </div>
    </>
  );
};

export default RfqItems;
